<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t0.title')"
      :textArray="[$t('privacy.t0.p0'), $t('privacy.t0.p1'), $t('privacy.t0.p2')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t1.title')"
      :textArray="[$t('privacy.t1.p0')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t2.title')"
      :textArray="[$t('privacy.t2.p0')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t3.title')"
      :textArray="[$t('privacy.t3.p0'), $t('privacy.t3.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t4.title')"
      :subtitle="$t('privacy.t4.subtitle')"
      :textArray="[$t('privacy.t4.p0'), $t('privacy.t4.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t5.title')"
      :subtitle="$t('privacy.t5.subtitle')"
      :textArray="[$t('privacy.t5.p0')]"
    >
      <div slot="content">
        <ul>
          <li>{{ $t('privacy.t5.li0') }}</li>
          <li>{{ $t('privacy.t5.li1') }}</li>
          <li>{{ $t('privacy.t5.li2') }}</li>
          <li>{{ $t('privacy.t5.li3') }}</li>
          <li>{{ $t('privacy.t5.li4') }}</li>
        </ul>
        <br>
        {{ $t('privacy.t5.extra') }}
      </div>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t6.title')"
      :textArray="[$t('privacy.t6.p0'), $t('privacy.t6.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t7.title')"
      :textArray="[$t('privacy.t7.p0'), $t('privacy.t7.p1'), $t('privacy.t7.p2')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t8.title')"
      :textArray="[$t('privacy.t8.p0'), $t('privacy.t8.p1')]"
    >
      <div slot="content">
        <ul>
          <li>{{ $t('privacy.t8.li0') }}</li>
          <li>{{ $t('privacy.t8.li1') }}</li>
        </ul>
        <br>
        {{ $t('privacy.t8.extra') }}
      </div>
    </ContentTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t9.title')"
      :textArray="[$t('privacy.t9.p0'), $t('privacy.t9.p1'), $t('privacy.t9.p2'), $t('privacy.t9.p3')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t10.title')"
      :textArray="[$t('privacy.t10.p0')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('privacy.t11.title')"
      :textArray="[$t('privacy.t11.p0')]"
      :downloadText="$t('privacy.t11.download')"
      downloadFileName="Flyer_Abteilung_Unterricht_am_Krankenbett.pdf"
    />
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'

import ContentTile from '@/views/components/ContentTile.vue'
import ContentFrame from '@/views/components/ContentFrame.vue'

export default {
  name: 'Privacy',
  components: {
    ContentTile,
    ContentFrame
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.privacy.color
    },
    computedTitle () {
      return this.menuData.privacy.title
    }
  }
}
</script>

<style scoped>
  .v-data-table {
    border-radius: 0px !important;
  }
</style>
